import React, { useState } from "react";
import { Container, Box, TextField, Button, Typography, Paper, Snackbar, Alert } from "@mui/material";
import axios from "axios";
import BaseURL from "./../api/AppURL";

const ChangePassword = ({ onSaveSuccess }) => {
  const [formData, setFormData] = useState({
    old_password: "",
    new_password: "",
    new_password_confirmation: "",
  });

  const [loading, setLoading] = useState(false);

  // Snackbar state
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // success | error | warning | info
  });

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.new_password !== formData.new_password_confirmation) {
      setSnackbar({
        open: true,
        message: "New password and Confirm password do not match!",
        severity: "error",
      });
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem("auth_token");

      const response = await axios.post(`${BaseURL}/vendor/update/password`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const successMessage = response.data.message || "Password updated successfully!";

      if (typeof onSaveSuccess === "function") {
        onSaveSuccess(successMessage);
      } else {
        setSnackbar({
          open: true,
          message: successMessage,
          severity: "success",
        });
      }

      setFormData({
        old_password: "",
        new_password: "",
        new_password_confirmation: "",
      });
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.response?.data?.message || "Something went wrong!",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 5 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom>
          Change Password
        </Typography>

        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ display: "flex", flexDirection: "column", gap: 2 }}
        >
          <TextField
            label="Old Password"
            type="password"
            name="old_password"
            value={formData.old_password}
            onChange={handleChange}
            fullWidth
            required
          />

          <TextField
            label="New Password"
            type="password"
            name="new_password"
            value={formData.new_password}
            onChange={handleChange}
            fullWidth
            required
          />

          <TextField
            label="Confirm New Password"
            type="password"
            name="new_password_confirmation"
            value={formData.new_password_confirmation}
            onChange={handleChange}
            fullWidth
            required
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Changes"}
          </Button>
        </Box>
      </Paper>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} variant="filled">
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default ChangePassword;
